(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class PbHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this;
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-pb-menu-open]');
      this.closeButton = this.querySelector('[data-pb-menu-close]');
      this.lastY = window.scrollY;
      this.ticking = false;

      this.onOpen = () => {
        this.section.removeAttribute('data-pb-hidden');
        this.dialog.showModal();
        this.openButton.setAttribute('aria-expanded', 'true');
      };
      this.onClose = () => this.dialog.close();
      this.onDialogClose = () => {
        this.openButton.setAttribute('aria-expanded', 'false');
        this.openButton.focus();
      };
      this.onFocusIn = () => this.section.removeAttribute('data-pb-hidden');
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => this.updateOnScroll());
      };

      this.openButton.addEventListener('click', this.onOpen);
      this.closeButton.addEventListener('click', this.onClose);
      this.dialog.addEventListener('close', this.onDialogClose);
      this.addEventListener('focusin', this.onFocusIn);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    /* Hide while scrolling down past the header, show again on any scroll up. Small moves (under 4px) are ignored. */
    updateOnScroll() {
      const y = window.scrollY;
      const delta = y - this.lastY;

      if (y <= this.offsetHeight) {
        this.section.removeAttribute('data-pb-hidden');
      } else if (delta > 4) {
        this.section.setAttribute('data-pb-hidden', '');
      } else if (delta < -4) {
        this.section.removeAttribute('data-pb-hidden');
      }

      if (Math.abs(delta) > 4 || y <= this.offsetHeight) this.lastY = y;
      this.ticking = false;
    }
  }

  if (!customElements.get('pb-header')) customElements.define('pb-header', PbHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-about"] && !Shopify.designMode) return;
  try {
    
  /*
   * The table of contents of the About page: one row per part that has a name (blocks/_pb-about-part.liquid, data-pb-toc-label),
   * in the order of the parts on the page, each row a link to the part's anchor. Numbers 01, 02… when data-numbered is set.
   * In the theme editor, the rows follow the parts while they are added, renamed or moved.
   */
  class PbAboutToc extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section') || document;
      this.list = this.querySelector('ol');
      this.pending = false;
      this.build();

      if (window.Shopify && window.Shopify.designMode) {
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['id', 'data-pb-toc-label'],
        });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    schedule() {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => {
        this.pending = false;
        this.build();
      });
    }

    build() {
      const parts = [...this.root.querySelectorAll('[data-pb-toc-label]')].filter(
        (part) => part.id && part.dataset.pbTocLabel.trim() !== ''
      );

      const items = parts.map((part, index) => {
        const item = document.createElement('li');
        item.className = 'pb-about-toc__item';

        const link = document.createElement('a');
        link.className = 'pb-about-toc__link';
        link.href = `#${encodeURIComponent(part.id)}`;

        if (this.hasAttribute('data-numbered')) {
          const number = document.createElement('span');
          number.className = 'pb-about-toc__number';
          number.textContent = String(index + 1).padStart(2, '0');
          /* The number and the name sit in two grid columns; this hidden space keeps them apart when read out ("01 BRAND STORY 物語"). */
          const space = document.createElement('span');
          space.className = 'pb-visually-hidden';
          space.textContent = ' ';
          link.append(number, space);
        }

        const label = document.createElement('span');
        label.className = 'pb-about-toc__label';
        label.textContent = part.dataset.pbTocLabel.trim();
        link.append(label);

        item.append(link);
        return item;
      });

      this.list.replaceChildren(...items);
      this.hidden = items.length === 0;
    }
  }

  if (!customElements.get('pb-about-toc')) customElements.define('pb-about-toc', PbAboutToc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-main"] && !Shopify.designMode) return;
  try {
    
  /* The cart that opens from the side (PD7). Its lines come back from Liquid through the Section Rendering API after every change. */
  class PbCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.pbReady) return;
      this.pbReady = true;
      this.dialog = this.querySelector('dialog');
      this.status = this.querySelector('[data-pb-drawer-status]');
      this.error = this.querySelector('[data-pb-drawer-error]');

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-pb-drawer-close]')) {
          this.dialog.close();
          return;
        }

        const control = event.target.closest('[data-pb-line]');
        if (control) {
          if (control.getAttribute('aria-disabled') !== 'true') {
            this.change(control.dataset.pbLine, Number(control.dataset.pbQuantity), control.dataset.pbRole);
          }
          return;
        }

        /* A tap on the dimmed page beside the panel closes the cart. */
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          const inside =
            event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
          if (!inside) this.dialog.close();
        }
      });

      this.dialog.addEventListener('close', () => {
        if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus();
      });
    }

    /* This section and the header, rendered again together with the cart change (bundled section rendering). */
    sectionIds() {
      const ids = [this.dataset.sectionId];
      const header = document.querySelector('.pb-header-section');
      if (header && header.id) ids.push(header.id.replace(/^shopify-section-/, ''));
      return ids;
    }

    open(returnFocus, message) {
      this.returnFocus = returnFocus;
      this.hideError();
      if (!this.dialog.open) this.dialog.showModal();
      this.announce(message);
    }

    announce(message) {
      if (!this.status || !message) return;
      this.status.textContent = '';
      window.setTimeout(() => {
        this.status.textContent = message;
      }, 100);
    }

    /* Swap in the cart lines and the header's cart count that Liquid just rendered. The header file itself is not changed. */
    render(sections) {
      if (!sections) return;
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

      const html = sections[this.dataset.sectionId];
      if (html) {
        const fresh = parse(html).querySelector('[data-pb-cart-content]');
        const current = this.querySelector('[data-pb-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
      }

      const header = document.querySelector('.pb-header-section');
      const headerHtml = header && header.id ? sections[header.id.replace(/^shopify-section-/, '')] : null;
      if (headerHtml) {
        const fresh = parse(headerHtml).querySelector('.pb-header__end');
        const current = header.querySelector('.pb-header__end');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
    }

    async change(key, quantity, role) {
      if (this.busy) return;
      this.busy = true;
      this.hideError();
      try {
        const response = await fetch(`${this.dataset.cartChangeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: this.sectionIds(),
            sections_url: window.location.pathname + window.location.search,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          this.showError(result.description || this.dataset.errorText);
          return;
        }
        this.render(result.sections);
        this.announce(this.dataset.updatedText);
        const next =
          this.querySelector(`[data-pb-line="${CSS.escape(key)}"][data-pb-role="${role}"]`) ||
          this.querySelector('[data-pb-drawer-close]');
        if (next) next.focus();
      } catch (error) {
        this.showError(this.dataset.errorText);
      } finally {
        this.busy = false;
      }
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
    }

    hideError() {
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = '';
    }
  }

  if (!customElements.get('pb-cart-drawer')) customElements.define('pb-cart-drawer', PbCartDrawer);

  /* The purchase part: choosing (nothing chosen at first, PD4), quantity, the bar at the bottom (PD1, PD2), the photos, and adding to the cart. */
  class PbProduct extends HTMLElement {
    connectedCallback() {
      if (this.pbReady) return;
      this.pbReady = true;

      const script = this.querySelector('[data-pb-variants]');
      const data = script ? JSON.parse(script.textContent) : {};
      this.variants = data.variants || [];
      this.defaultPrice = data.default_price || '';

      this.form = this.querySelector('.pb-pdp__form');
      this.idInput = this.querySelector('[data-pb-variant-id]');
      this.quantityInput = this.querySelector('[data-pb-quantity]');
      this.minusButton = this.querySelector('[data-pb-step="-1"]');
      this.addButton = this.querySelector('[data-pb-add]');
      this.error = this.querySelector('[data-pb-error]');
      this.price = this.querySelector('[data-pb-price]');
      this.fieldsets = Array.from(this.querySelectorAll('[data-pb-option]'));
      this.bar = this.querySelector('[data-pb-buybar]');
      this.barChoice = this.querySelector('[data-pb-buybar-choice]');
      this.barPrice = this.querySelector('[data-pb-buybar-price]');
      this.barButton = this.querySelector('[data-pb-buybar-button]');
      this.gallery = this.querySelector('[data-pb-gallery]');
      this.thumbs = Array.from(this.querySelectorAll('.pb-gallery__thumb'));
      /* A frame (in the list or full screen) keeps its linen until its photo is there (a cached photo is complete at once). A frame without an <img> (video, model) is marked right away. */
      this.querySelectorAll('.pb-gallery__item, .pb-lightbox__item').forEach((item) => {
        const image = item.querySelector('img');
        const mark = () => item.setAttribute('data-pb-loaded', '');
        if (!image || image.complete) mark();
        else image.addEventListener('load', mark, { once: true });
      });
      this.lightbox = this.querySelector('[data-pb-lightbox]');
      this.drawer = this.querySelector('pb-cart-drawer');

      this.addEventListener('change', (event) => {
        if (event.target.classList.contains('pb-chip__input')) this.update(true);
        if (event.target === this.quantityInput) this.normalizeQuantity();
      });

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-pb-step]');
        if (step) this.stepQuantity(Number(step.dataset.pbStep));
        const zoom = event.target.closest('[data-pb-zoom]');
        if (zoom) this.openLightbox(zoom.dataset.pbZoom, zoom);
        if (event.target.closest('[data-pb-lightbox-close]') && this.lightbox) this.lightbox.close();
        if (event.target.closest('[data-pb-buybar-summary]')) this.goToChoice();
        const go = event.target.closest('[data-pb-gallery-go]');
        if (go && this.gallery) this.gallery.scrollTo({ left: Number(go.dataset.pbGalleryGo) * this.gallery.clientWidth, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        const arrow = event.target.closest('[data-pb-gallery-step]');
        /* The arrows go round: next on the last photo returns to the first, previous on the first goes to the last. */
        if (arrow && this.gallery) {
          const count = this.thumbs.length || 1;
          const width = this.gallery.clientWidth || 1;
          const index = (Math.round(this.gallery.scrollLeft / width) + Number(arrow.dataset.pbGalleryStep) + count) % count;
          this.gallery.scrollTo({ left: index * width, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        }
      });

      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));
      if (this.lightbox) {
        this.lightbox.addEventListener('close', () => {
          if (this.lightboxReturn && this.lightboxReturn.isConnected) this.lightboxReturn.focus({ preventScroll: true });
        });
      }
      if (this.gallery) {
        this.gallery.addEventListener('scroll', () => this.onGalleryScroll(), { passive: true });
        this.onGalleryScroll();
      }

      /*
       * The bar shows once the button has left the screen upwards, and hides when the button is back (one filled button per screen).
       * Measured on every scroll frame, not with an IntersectionObserver: a jump (an anchor, the back button, a fast swipe) can carry
       * the button from below the screen to above it without crossing it, and the observer would then never fire (P9 check, 2026-10-08).
       */
      this.onScroll = () => {
        if (this.barFrame) return;
        this.barFrame = window.requestAnimationFrame(() => {
          this.barFrame = null;
          this.bar.toggleAttribute('data-visible', this.addButton.getBoundingClientRect().bottom < 0);
        });
      };
      if (this.bar && this.addButton) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      this.update(false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    selectedValues() {
      return this.fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('.pb-chip__input:checked');
        return checked ? checked.value : null;
      });
    }

    /* Variants that match every chosen value; an option not chosen yet matches anything. */
    matching(values) {
      return this.variants.filter((variant) =>
        values.every((value, index) => value === null || variant.options[index] === value)
      );
    }

    update(byCustomer) {
      const values = this.selectedValues();
      const complete = !values.includes(null);
      let variant = null;
      if (this.fieldsets.length === 0) variant = this.variants[0] || null;
      else if (complete) variant = this.matching(values)[0] || null;

      /* A value is sold out when no variant with it, and with the other choices already made, can be bought. */
      this.fieldsets.forEach((fieldset, index) => {
        fieldset.querySelectorAll('.pb-chip__input').forEach((input) => {
          const probe = values.slice();
          probe[index] = input.value;
          const available = this.matching(probe).some((item) => item.available);
          input.disabled = !available;
          const soldOut = input.parentElement.querySelector('[data-pb-soldout]');
          if (soldOut) soldOut.hidden = available;
        });
        const current = fieldset.querySelector('[data-pb-option-current]');
        if (current) current.textContent = values[index] === null ? '' : `: ${values[index]}`;
      });

      let state = 'add';
      if (!this.variants.some((item) => item.available)) state = 'sold-out';
      else if (!variant) state = complete ? 'sold-out' : 'choose';
      else if (!variant.available) state = 'sold-out';
      this.state = state;

      if (this.idInput) this.idInput.value = variant ? variant.id : '';
      this.setButton(this.addButton, state, this.dataset.labelChoose);
      this.setButton(this.barButton, state, this.dataset.labelBarChoose);

      const price = variant ? variant.price : this.defaultPrice;
      if (this.price) this.price.innerHTML = price;
      if (this.barPrice) this.barPrice.innerHTML = price;
      this.updateBarChoice(values);

      if (byCustomer) {
        this.hideError();
        this.moveGallery(values);
        this.updateUrl(complete && this.fieldsets.length > 0 ? variant : null);
      }
    }

    setButton(button, state, chooseLabel) {
      if (!button) return;
      button.dataset.state = state;
      button.disabled = state === 'sold-out';
      if (state === 'add') button.textContent = this.dataset.labelAdd;
      else if (state === 'choose') button.textContent = chooseLabel;
      else button.textContent = this.dataset.labelSoldOut;
    }

    /* The bar repeats what is chosen, and the quantity when it is more than one (PD2: so that nobody buys the wrong thing). */
    updateBarChoice(values = this.selectedValues()) {
      if (!this.barChoice) return;
      const parts = [];
      const chosen = values.filter((value) => value !== null).join('・');
      if (chosen) parts.push(chosen);
      const quantity = this.quantityInput ? Number(this.quantityInput.value) || 1 : 1;
      if (quantity > 1) parts.push(`× ${quantity}`);
      this.barChoice.textContent = parts.join(' ');
    }

    stepQuantity(delta) {
      if (!this.quantityInput) return;
      this.quantityInput.value = (Number(this.quantityInput.value) || 1) + delta;
      this.normalizeQuantity();
    }

    normalizeQuantity() {
      const value = Math.max(1, Math.floor(Number(this.quantityInput.value)) || 1);
      this.quantityInput.value = value;
      if (this.minusButton) this.minusButton.setAttribute('aria-disabled', String(value <= 1));
      this.updateBarChoice();
    }

    /* Back to the first option still to choose (the button before choosing, and the left part of the bar). */
    goToChoice() {
      const values = this.selectedValues();
      const target = this.fieldsets[values.indexOf(null)] || this.fieldsets[0] || this.querySelector('.pb-pdp__info');
      if (!target) return;
      /* Beside the photos on a wide screen the purchase part stays in view: when the choice is already on the screen, only the focus moves and the page stays where it is. */
      const info = this.querySelector('.pb-pdp__info');
      const box = target.getBoundingClientRect();
      const inView =
        info && window.getComputedStyle(info).position === 'sticky' && box.top >= 0 && box.bottom <= window.innerHeight;
      if (!inView) target.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'center' });
      const input =
        target.querySelector('.pb-chip__input:checked') || target.querySelector('.pb-chip__input:not(:disabled)');
      if (input) input.focus({ preventScroll: true });
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.state === 'choose') {
        this.goToChoice();
        return;
      }
      if (this.state !== 'add' || this.busy) return;
      this.addToCart(event.submitter || this.addButton);
    }

    async addToCart(submitter) {
      this.busy = true;
      this.hideError();
      [this.addButton, this.barButton].forEach((button) => button && button.setAttribute('aria-busy', 'true'));

      const body = new FormData(this.form);
      const sections = this.drawer && this.drawer.sectionIds ? this.drawer.sectionIds() : [];
      if (sections.length > 0) {
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname + window.location.search);
      }

      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          this.showError(result.description || this.dataset.errorText, submitter);
          return;
        }
        if (this.drawer && this.drawer.open) {
          this.drawer.render(result.sections);
          this.drawer.open(submitter, this.dataset.addedText);
        }
      } catch (error) {
        this.showError(this.dataset.errorText, submitter);
      } finally {
        this.busy = false;
        [this.addButton, this.barButton].forEach((button) => button && button.removeAttribute('aria-busy'));
      }
    }

    showError(message, submitter) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
      if (submitter === this.barButton) {
        this.error.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }

    hideError() {
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = '';
    }

    /* A choice shows the image of the first variant still possible (Konomi, 2026-10-20: the photo must follow the design and the handles). */
    moveGallery(values) {
      if (!this.gallery) return;
      const first = this.matching(values).find((variant) => variant.media);
      const item = first ? this.gallery.querySelector(`[data-media-id="${first.media}"]`) : null;
      if (item) this.gallery.scrollTo({ left: item.offsetLeft, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    /* A full choice is kept in the address (?variant=), so that a reload or a shared link opens with the same choice. Not in the theme editor. */
    updateUrl(variant) {
      if (window.Shopify && window.Shopify.designMode) return;
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      window.history.replaceState(window.history.state, '', url.toString());
    }

    onGalleryScroll() {
      if (this.thumbs.length === 0 || this.galleryFrame) return;
      this.galleryFrame = window.requestAnimationFrame(() => {
        this.galleryFrame = null;
        const index = Math.round(this.gallery.scrollLeft / (this.gallery.clientWidth || 1));
        this.thumbs.forEach((thumb, thumbIndex) => thumb.toggleAttribute('data-current', thumbIndex === index));
      });
    }

    /* Full-screen photos, opened on the photo that was pressed; closing gives the focus back to that photo. */
    openLightbox(mediaId, trigger) {
      if (!this.lightbox) return;
      this.lightboxReturn = trigger;
      this.lightbox.showModal();
      const list = this.lightbox.querySelector('[data-pb-lightbox-list]');
      const item = list ? list.querySelector(`[data-media-id="${mediaId}"]`) : null;
      if (item) list.scrollLeft = item.offsetLeft;
    }
  }

  if (!customElements.get('pb-product')) customElements.define('pb-product', PbProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-story"] && !Shopify.designMode) return;
  try {
    
  /* Story folding (wireframes-product-about.md 3.1): fold after the first lines only when the story is longer than one more line. */
  class PbStory extends HTMLElement {
    connectedCallback() {
      if (this.pbReady) return;
      this.pbReady = true;
      this.text = this.querySelector('.pb-pdp-story__text');
      this.toggle = this.querySelector('[data-pb-story-toggle]');
      if (!this.text || !this.toggle) return;
      this.lines = Number(this.dataset.lines) || 5;

      this.toggle.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'));
      this.measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.measure());
    }

    measure() {
      if (this.toggle.getAttribute('aria-expanded') === 'true') return;
      this.removeAttribute('data-collapsed');
      const lineHeight = parseFloat(window.getComputedStyle(this.text).lineHeight) || 28.8;
      const tooLong = this.text.scrollHeight > lineHeight * (this.lines + 1) + 1;
      this.style.setProperty('--pb-story-height', `${Math.round(lineHeight * this.lines)}px`);
      this.toggleAttribute('data-collapsed', tooLong);
      this.toggle.hidden = !tooLong;
    }

    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggleAttribute('data-collapsed', !open);
      this.querySelector('[data-pb-story-more]').hidden = open;
      this.querySelector('[data-pb-story-less]').hidden = !open;
      if (!open) {
        const part = this.closest('.pb-pdp-story');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (part) part.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      }
    }
  }

  if (!customElements.get('pb-story')) customElements.define('pb-story', PbStory);

  } catch(e) { console.error(e); }
})();
})();
